import React from 'react';
import { Row, Col, Typography, Input } from 'antd';

const { Text } = Typography;

export default function CustomerSection({ selectedContact, statusGrup }) {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
                <Text strong>Nama Perusahaan *</Text>
                <Input
                    value={selectedContact?.name || 'Belum dipilih'}
                    disabled
                    style={{ marginTop: 4, backgroundColor: '#f5f5f5' }}
                    placeholder="Customer akan terisi otomatis dari data NOPEN"
                />
            </Col>

            <Col xs={24} md={12}>
                <Text strong>Status Grup</Text>
                <Input
                    value={statusGrup || 'Menunggu data customer...'}
                    disabled
                    style={{ marginTop: 4, backgroundColor: '#f5f5f5' }}
                />
            </Col>
        </Row>
    );
}
